import { Box } from "@mui/system";
import React from "react";
import userTemImage from "../../assets/img/user.jpg";
import PopupProfile from "./PopupProfile";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useNavigate } from "react-router";
import NotificationMenu from './NotificationMenu'
import host from "../../assets/js/Host";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { useDispatch, useSelector } from "react-redux";
import { setShowAppListOfUpdates } from "../../reduxStore/SettingsReducer";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
function AppBarItems(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const userImageRedux = useSelector(state => state.userData.userImage)
  const handleClose = () => {
    setAnchorEl(null);
  };
  const getUserImageURL = () => {
    let temImage = userTemImage;
    if (userImageRedux) {
      temImage = host + userImageRedux;
    }
    return temImage
  }
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <span style={{ fontFamily: "Cairo-Bold", color: "#000", marginLeft: !props?.open ? '123px' : '330px', fontSize: '20px', transition: 'margin 0.5s ease-in-out !important' }}>
            {props?.getTitle()}
          </span>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "center",
            justifyContent: 'flex-end',
            transition: "all 0.7 ease-in-out !important",

          }}
        >
          <Box
            sx={{
              backgroundColor: "rgb(223,226,231)",
              border: '2px solid #ff3970',
              // padding: "10px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 4px",
              marginRight: "15px",
              overflow: "hidden",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <img
              src={getUserImageURL()}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover !important",
                // backgroundSize: "center center",
              }}
            />
          </Box>
          <Box
            sx={{
              // backgroundColor: "rgb(223,226,231)",
              padding: "10px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 4px",
              overflow: "hidden",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.1)",
                backgroundColor: "rgb(223,226,231)",
              },
            }}
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={() => {
              navigate("Users");
            }}
          >
            <PeopleAltIcon
              color="rgb(99,115,129)"
              sx={{ color: "rgb(99,115,129)" }}
            />
          </Box>
     
          {localStorage.getItem('roles') && JSON.parse(localStorage.getItem('roles'))?.includes(95) ? <Box
            sx={{
              padding: "10px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 4px",
              overflow: "hidden",
              cursor: "pointer",
              "&:hover": {
                transform: "scale(1.1)",
                backgroundColor: "rgb(223,226,231)",
              },
            }}
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={() => {
              navigate("update-contents");
            }}
          >
            <AutoAwesomeIcon
              color="rgb(99,115,129)"
              sx={{ color: "rgb(99,115,129)" }}
            />
          </Box> : null}
          {localStorage.getItem('roles') && JSON.parse(localStorage.getItem('roles'))?.includes(74) ? <NotificationMenu /> : null}
          <Box
            className="circular-border-custom"
          >
            <Box
              sx={{
                width: 'fit-content',
                height: '35px',
                borderRadius: '20px',
                backgroundColor: '#f3f3f3',
                boxShadow: '0 0 3px -3px #000',
                color: '#000',
                textAlign: 'center',
                padding: '5px 10px',
                cursor: 'pointer',
              }}
              onClick={() => {
                dispatch(setShowAppListOfUpdates(true));
              }}
            >
              <ArrowDropDownIcon sx={{ color: '#000', marginRight: '5px' }} />
              version : <span>{require('../../../package.json')?.version}</span>
            </Box>
          </Box>



        </Box>
      </Box>
      <PopupProfile
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        open={open}
        handleClick={handleClick}
        handleClose={handleClose}
        logout={props?.logout}
      />
    </>
  );
}

export default AppBarItems;
